import { ThemeProvider } from '@mui/material';
import theme from '@/styles/theme';

const AgaveProvider = ({ children }: any) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
export default AgaveProvider;